import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import demoData from './demoData'
import { getClientKeyWithAccessToken } from '../lib/security'

const baseUrl = process.env.REACT_APP_CLIENT_SERVICES_API

const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: async (headers, { getState }) => {
    const { accessToken } = getState().login
    const clientKey = await getClientKeyWithAccessToken(accessToken)
    headers.set('Authorization', `Bearer ${accessToken}`)
    headers.set('clientKey', clientKey)
    return headers
  },
  fetchFn: async (...args) => {
    if (process.env.REACT_APP_IS_DEMO) {
      const url = new URL(args[0]?.url)
      const body = demoData[args[0]?.method][url?.pathname] || {}
      return new Response(JSON.stringify(body), {
        status: 200,
        statusText: 'OK',
        headers: {
          'content-type': 'application/json; charset=utf-8',
        },
      })
    }
    return fetch(...args)
  },
})

export const clientServicesApi = createApi({
  reducerPath: 'clientServicesApi',
  baseQuery,
  endpoints: (builder) => ({
    findContracts: builder.query({
      query: () => {
        return {
          url: `/contracts`,
        }
      },
    }),
    findConsumptions: builder.query({
      query: ({ tenant }) => {
        return {
          url: `/clients/consumptions`,
          params: { tenant },
        }
      },
    }),
    findConsumptionsByContractId: builder.query({
      query: ({ contractId }) => {
        return {
          url: `/clients/consumptions/${contractId}`,
        }
      },
    }),
    findConsumptionsByTenant: builder.query({
      query: ({ status, groupBy, tenant, fromDate, toDate }) => {
        return {
          url: `/metrics/consumptions`,
          params: { status, groupBy, tenant, fromDate, toDate },
        }
      },
    }),
  }),
})
